import { ContentChild, Directive, ElementRef, HostBinding, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';

@Directive({
  selector: '[matFormFieldWaiting]'
})
export class MatFormFieldWaitingDirective implements OnChanges {

	private doneTimeout;

	@ContentChild(MatFormFieldControl) formFieldControl: MatFormFieldControl<any>;
	@HostBinding('class.mat-form-field-waiting') @Input('matFormFieldWaiting') formFieldWaiting: boolean = false;

	constructor(private elementRef: ElementRef,
				private renderer: Renderer2) { }

	ngOnChanges(changes: SimpleChanges): void {

		this.renderer.removeClass(this.elementRef.nativeElement, 'mat-form-field-waiting-done');

		if(!this.formFieldControl?.ngControl.valid)
			this.formFieldWaiting = false;

		else if(changes.formFieldWaiting.previousValue === true &&
			changes.formFieldWaiting.currentValue === false) {

			if(this.doneTimeout)
				clearTimeout(this.doneTimeout);

			this.renderer.addClass(this.elementRef.nativeElement, 'mat-form-field-waiting-done');
			this.doneTimeout = setTimeout(() => this.renderer.removeClass(this.elementRef.nativeElement, 'mat-form-field-waiting-done'), 3000);
		}
	}
}
